// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"aab44c2d","763":"dd7798d4","856":"50d801ad"}[chunkId] + ".js";
};